import { configureStore } from '@reduxjs/toolkit';
import SessionReducer from './Session';
import UIReducer from './UI';
import AppReducer from './App';
import NavigationReducer from './Navigation';
import NotificationReducer from './Notification';

export default configureStore({
  reducer: {
    session: SessionReducer,
    ui: UIReducer,
    app: AppReducer,
    navigation: NavigationReducer,
    notification: NotificationReducer
  }
});
